import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import type { HelpModule, HelpSection } from '@/data/helpManual';

function SectionBody({ body }: { body: string }) {
  const blocks = body.split(/\n\n+/);
  return (
    <div className="space-y-3">
      {blocks.map((block, i) => {
        const lines = block.split('\n');
        const isList = lines.every((l) => l.trim().startsWith('- '));
        if (isList) {
          return (
            <ul key={i} className="list-disc pl-5 space-y-1 text-sm text-foreground/90">
              {lines.map((l, j) => (
                <li key={j}>{l.replace(/^\s*-\s*/, '')}</li>
              ))}
            </ul>
          );
        }
        return (
          <p key={i} className="text-sm leading-relaxed text-foreground/90 whitespace-pre-line">
            {block}
          </p>
        );
      })}
    </div>
  );
}

interface Props {
  module: HelpModule;
  onBack: () => void;
}

export function HelpModuleContent({ module, onBack }: Props) {
  return (
    <div className="space-y-5">
      <Button variant="ghost" size="sm" onClick={onBack} className="-ml-2 gap-1.5">
        <ArrowLeft className="w-4 h-4" />
        Volver al índice
      </Button>

      <div className="space-y-2">
        <h3 className="text-xl font-bold text-foreground">{module.title}</h3>
        <p className="text-sm text-muted-foreground">{module.shortDescription}</p>
      </div>

      <div className="space-y-5">
        {module.sections.map((s: HelpSection, i) => (
          <section key={i} className="space-y-2">
            <h4 className="text-sm font-semibold text-foreground">{s.heading}</h4>
            <SectionBody body={s.body} />
          </section>
        ))}
      </div>
    </div>
  );
}
